import React from "react";
import { Api_EndPoints } from "../../utils/Api_EndPoints";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";

const addDesignation = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.AddDesignation, input);
  return data;
};

export const useAddDesignationMutation = () => {
  return useMutation({
    mutationFn: addDesignation,
  });
};
